import React from 'react'
import { useNavigate } from 'react-router-dom'

import { usePlaid } from './PlaidContext'
import { MessageTypes, QuestionSetSlug, Routes } from '@mortgage-pos/types'
import { useStoreActions, useStoreState } from '@mortgage-pos/ui/store'
import Button, { ButtonVariants } from '@mortgage-pos/ui/components/Button'

export const ManualUploadOption = () => {
  const navigate = useNavigate()
  const { setUsePlaidUpload } = usePlaid()
  const { isMiniFlow } = useStoreState((state) => state.questionnaire)
  const { closeMiniFlow } = useStoreActions((state) => state.questionnaire)
  const uploadDocumentManually = useStoreActions(
    (state) => state.tracking.uploadDocumentManually
  )

  const uploadManuallyHandler = () => {
    uploadDocumentManually()
    setUsePlaidUpload(false)

    if (isMiniFlow) {
      closeMiniFlow({
        parentMessage: {
          name: MessageTypes.MiniFlowConditionRequest,
          payload: {
            condition: 'Upload 2 months of asset statements',
          },
        },
      })
    } else {
      navigate(
        `/${Routes.APP_1003}?question-set=${QuestionSetSlug.ApplyPurchase}`
      )
      window.location.reload()
    }
  }

  return (
    <div className="plaid-assets__content">
      <div className="plaid-assets__header">
        <p className="plaid-assets__title">Traditional</p>
        <p className="plaid-assets__heading">Manually upload your documents</p>
        <p className="plaid-assets__description">
          Upload key documents that your broker would need including: bank
          statements, tax documents, paystubs and others.
        </p>
      </div>

      <Button
        className="plaid-assets__cta-link"
        onClick={uploadManuallyHandler}
        variant={ButtonVariants.default}
        content="Upload documents manually >"
      />
    </div>
  )
}

export default ManualUploadOption
